export const popularDestinations = [
  {
    id: 1,
    name: 'Milano',
    nameRo: 'Milano',
    type: 'City',
    typeRo: 'Oraș',
    typeIt: 'Città',
    priceFrom: 375,
    image: 'https://images.unsplash.com/photo-1513581166391-887a96ddeafd?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-city', to: 'milan' }
  },
  {
    id: 2,
    name: 'Cervinia',
    nameRo: 'Cervinia',
    type: 'Ski Resort',
    typeRo: 'Stațiune Ski',
    typeIt: 'Località Sciistica',
    priceFrom: 328,
    image: 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-airport', to: 'cervinia' }
  },
  {
    id: 3,
    name: 'Sestriere',
    nameRo: 'Sestriere',
    type: 'Ski Resort',
    typeRo: 'Stațiune Ski',
    typeIt: 'Località Sciistica',
    priceFrom: 293,
    image: 'https://images.unsplash.com/photo-1605540436563-5bca919ae766?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-airport', to: 'sestriere' }
  },
  {
    id: 4,
    name: 'Courmayeur',
    nameRo: 'Courmayeur',
    type: 'Ski Resort',
    typeRo: 'Stațiune Ski',
    typeIt: 'Località Sciistica',
    priceFrom: 386,
    image: 'https://images.unsplash.com/photo-1519904981063-b0cf448d479e?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-city', to: 'courmayeur' }
  },
  {
    id: 5,
    name: 'Alba',
    nameRo: 'Alba',
    type: 'City',
    typeRo: 'Oraș',
    typeIt: 'Città',
    priceFrom: 263,
    image: 'https://images.unsplash.com/photo-1645794225645-6fc366b25bbf?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-city', to: 'langhe' }
  },
  {
    id: 6,
    name: 'Barolo',
    nameRo: 'Barolo',
    type: 'Destination',
    typeRo: 'Destinație',
    typeIt: 'Destinazione',
    priceFrom: 211,
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-city', to: 'langhe' }
  },
  {
    id: 7,
    name: 'Genova',
    nameRo: 'Genova',
    type: 'City',
    typeRo: 'Oraș',
    typeIt: 'Città',
    priceFrom: 457,
    image: 'https://images.unsplash.com/photo-1589564781624-5c8e0b0e8e1e?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-city', to: 'genoa' }
  },
  {
    id: 8,
    name: 'Nizza',
    nameRo: 'Nisa',
    type: 'City',
    typeRo: 'Oraș',
    typeIt: 'Città',
    priceFrom: 726,
    image: 'https://images.unsplash.com/photo-1583422409516-2895a77efded?auto=compress&cs=tinysrgb&w=800',
    country: 'fr',
    route: { from: 'turin-city', to: 'nice' }
  },
  {
    id: 9,
    name: 'Stresa',
    nameRo: 'Stresa',
    type: 'Destination',
    typeRo: 'Destinație',
    typeIt: 'Destinazione',
    priceFrom: 363,
    image: 'https://images.unsplash.com/photo-1527004013197-933c4bb611b3?auto=compress&cs=tinysrgb&w=800',
    country: 'it',
    route: { from: 'turin-city', to: 'milan' }
  }
];

export const popularRoutes = [
  { from: 'Aeroporto Torino', fromRo: 'Aeroportul Torino', to: 'Torino', toRo: 'Torino' },
  { from: 'Torino', fromRo: 'Torino', to: 'Milano', toRo: 'Milano' },
  { from: 'Aeroporto Torino', fromRo: 'Aeroportul Torino', to: 'Cervinia', toRo: 'Cervinia' },
  { from: 'Torino', fromRo: 'Torino', to: 'Barolo', toRo: 'Barolo' },
  { from: 'Aeroporto Malpensa', fromRo: 'Aeroportul Malpensa', to: 'Torino', toRo: 'Torino' },
  { from: 'Torino', fromRo: 'Torino', to: 'Courmayeur', toRo: 'Courmayeur' },
  { from: 'Aeroporto Torino', fromRo: 'Aeroportul Torino', to: 'Alba', toRo: 'Alba' },
  { from: 'Torino', fromRo: 'Torino', to: 'Genova', toRo: 'Genova' },
  { from: 'Aeroporto Torino', fromRo: 'Aeroportul Torino', to: 'Sestriere', toRo: 'Sestriere' },
  { from: 'Torino', fromRo: 'Torino', to: 'Nizza', toRo: 'Nisa' },
  { from: 'Torino', fromRo: 'Torino', to: 'Stresa', toRo: 'Stresa' },
  { from: 'Torino', fromRo: 'Torino', to: 'Aosta', toRo: 'Aosta' }
];

export const faqData = {
  ro: [
    {
      id: 1,
      question: "Prețurile sunt fixe?",
      answer: "Da. Prețul pe care îl vedeți la rezervare este prețul final. Nu există costuri ascunse, suplimente pentru trafic sau taxe surpriză. Prețul include vehiculul, șoferul, combustibilul, taxele de drum și asistența pentru bagaje."
    },
    {
      id: 2,
      question: "Vehiculul va fi împărțit cu alți pasageri?",
      answer: "Nu, niciodată. Toate transferurile noastre sunt private și exclusive. Vehiculul este rezervat exclusiv pentru dumneavoastră și grupul dumneavoastră. Fără străini, fără împărțire, fără abateri."
    },
    {
      id: 3,
      question: "Ce se întâmplă dacă zborul meu întârzie?",
      answer: "Monitorizăm toate zborurile în timp real. Dacă zborul dumneavoastră întârzie, șoferul va ajusta automat ora ridicării. Nu este nevoie să ne contactați - serviciul de monitorizare a zborurilor este inclus gratuit."
    },
    {
      id: 4,
      question: "Cum îl recunosc pe șofer?",
      answer: "Șoferul vă va aștepta cu un semn cu numele dumneavoastră. Pentru ridicările de la aeroport, șoferul va fi poziționat în zona de sosiri. Veți primi, de asemenea, numele și numărul de telefon al șoferului prin email înainte de transfer."
    },
    {
      id: 5,
      question: "Pot anula rezervarea?",
      answer: "Da. Anularea este gratuită cu până la 24 de ore înainte de transfer. Pentru anulările târzii (mai puțin de 24 de ore), nu se oferă rambursare. Pentru a anula, contactați-ne prin email sau WhatsApp cu referința rezervării dumneavoastră."
    },
    {
      id: 6,
      question: "Există un supliment pentru noapte?",
      answer: "Pentru transferurile între orele 22:00 și 06:00, se poate aplica un supliment de noapte. Prețul exact este întotdeauna afișat în timpul rezervării, înainte de confirmare."
    }
  ],
  it: [
    {
      id: 1,
      question: "I prezzi sono fissi?",
      answer: "Sì. Il prezzo che vedi al momento della prenotazione è il prezzo finale. Non ci sono costi nascosti, supplementi per traffico o tariffe a sorpresa. Il prezzo include il veicolo, l'autista, il carburante, i pedaggi e l'assistenza bagagli."
    },
    {
      id: 2,
      question: "Il veicolo sarà condiviso con altri passeggeri?",
      answer: "No, mai. Tutti i nostri trasferimenti sono privati ed esclusivi. Il veicolo è riservato esclusivamente per te e il tuo gruppo. Nessun estraneo, nessuna condivisione, nessuna deviazione."
    },
    {
      id: 3,
      question: "Cosa succede se il mio volo è in ritardo?",
      answer: "Monitoriamo tutti i voli in tempo reale. Se il tuo volo è in ritardo, l'autista regolerà automaticamente l'orario di ritiro. Non c'è bisogno di contattarci - il servizio di monitoraggio voli è incluso gratuitamente."
    },
    {
      id: 4,
      question: "Come riconosco l'autista?",
      answer: "L'autista ti aspetterà con un cartello con il tuo nome. Per i ritiri in aeroporto, l'autista sarà posizionato nell'area arrivi. Riceverai anche il nome e il numero di telefono dell'autista via email prima del trasferimento."
    },
    {
      id: 5,
      question: "Posso cancellare la prenotazione?",
      answer: "Sì. La cancellazione è gratuita fino a 24 ore prima del trasferimento. Per cancellazioni tardive (meno di 24 ore), non viene fornito alcun rimborso. Per cancellare, contattaci via email o WhatsApp con il riferimento della tua prenotazione."
    },
    {
      id: 6,
      question: "C'è un supplemento notturno?",
      answer: "Per i trasferimenti tra le 22:00 e le 06:00, potrebbe essere applicato un supplemento notturno. Il prezzo esatto viene sempre mostrato durante la prenotazione, prima della conferma."
    }
  ]
};
